import React from "react";
import { FormControl, Select, InputLabel, MenuItem, useTheme } from "@mui/material";
import { MarketTreeMapStyle } from "./MarketTreeMap.styles";
import { useAppDispatch } from "src/store/store";
import { trackEvent } from "src/Amplitude";

interface MarketTreeFormProps {
  title: string;
  toggleRedux: any;
  values: {
    id: number;
    option: string;
  }[];
}

const MarketTreeMapForm = (props: MarketTreeFormProps) => {
  const { values, title, toggleRedux } = props;
  // -----------------REDUX-------------------
  const dispatch = useAppDispatch();
  // -----------------Style-------------------
  const classes = MarketTreeMapStyle();
  const theme = useTheme();
  return (
    <FormControl size="small" fullWidth className={classes.filterTools}>
      <InputLabel id="selectLabel" focused={false} shrink={true}>
        {title}
      </InputLabel>
      <Select
        labelId="select-label"
        id="select"
        sx={{
          "&.MuiOutlinedInput-root": {
            "& fieldset": {},
            "&:hover fieldset": {
              borderColor: theme.palette.secondary.main,
            },
            "&.Mui-focused fieldset": {
              borderColor: theme.palette.secondary.main,
            },
          },
        }}
        label="Performance "
        defaultValue={values[0].option}
        onChange={(event) => {
          dispatch(toggleRedux(event.target.value));
        }}>
        {values.map((item, ind) => {
          return (
            <MenuItem
              onClick={() =>
                trackEvent(`Select_Market_Sectors_Page_Advanced_Options`, {
                  option: item.option,
                })
              }
              key={item.id}
              value={item.option}>
              {item.option}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default MarketTreeMapForm;
